<template>
  <md-modal-dialog v-slot="{
      title,
      message,
      confirmText,
      cancelText,
      confirmDisabled = false,
      cancelDisabled = false,
      options
    }"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false">

    <md-dialog-title>{{ title }}</md-dialog-title>
    <md-dialog-content>
      <span style="font-weight: bold">{{ message }}</span>
        <div v-for="(option, key) in options" :key="key">
          <md-checkbox v-model="localOptions[key]" :value="option.value">{{ option.label }}</md-checkbox>
        </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary md-flat" @click="onCancel" :disabled="cancelDisabled" v-if="cancelText">{{ cancelText }}</md-button>
      <md-button class="md-primary md-flat" @click="onConfirm" :disabled="confirmDisabled" v-if="confirmText">{{ confirmText }}</md-button>
    </md-dialog-actions>
  </md-modal-dialog>
</template>

<script>

import ValidatedInputs from '@/components/ValidatedInput';
export default {
  components: {
    ...ValidatedInputs,
  },
  data() {
    return {
      localOptions: {}
    };
  },
  methods: {
    onCancel() {
      this.$modal.cancel();
    },
    onConfirm() {
      this.$modal.submit({ confirmed: true, options: this.localOptions });
      return;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";
  .md-subheader {
    padding: 0px;
  }
</style>